<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="抖音落地页详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="5">标题:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">网址:</el-col>
        <el-col :span="19"><span ref='path'>https://h5.eiecho.com/douyin/index.html#/?appId={{ showForm.appId }}&pageId={{ showForm.pageId }}&title={{ encodeURIComponent(showForm.title) }}</span> <el-button type="primary" class="ml-10" @click="copy" size="mini" plain>复制</el-button></el-col>
      </el-row>
      <el-row>
        <el-col :span="5">商品:</el-col>
        <el-col :span="19">
          <el-tag v-for="(item,index) of showForm.basic.productList||[]" :key="index">
            {{item.productName}}(数量:{{item.count}})
          </el-tag>
          </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">详情图片:</el-col>
        <el-col :span="12">
          <el-carousel :interval="4000" height="160px" class="e-carousel">
            <el-carousel-item v-for="item in showForm.basic.imageList||[]" :key="item.name">
              <el-image :src="item.url" fit="scale-down"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">支付成功图片:</el-col>
        <el-col :span="12">
          <el-carousel :interval="4000" height="160px" class="e-carousel">
            <el-carousel-item v-for="item in showForm.basic.paymentSuccessImageList||[]" :key="item.name">
              <el-image :src="item.url" fit="scale-down"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">购买弹窗描述项目:</el-col>
        <el-col :span="19">
          <el-tag v-for="(item,index) of showForm.basic.itemList||[]" :key="index">
            {{item.title}}(数量:{{item.count}})
          </el-tag>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">购买弹窗倒计时:</el-col>
        <el-col :span="15">
          {{showForm.basic&&showForm.basic.clockTime}}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { findPage } from '@/api/shop'
export default {
  name: 'TiktokDetail',
  emits: ['fetch-data'],
  data() {
    return {
      showForm: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const pageId = row.pageId
      const data = await findPage({
        pageId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    copy() {
      const text = this.$refs.path.innerText
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功')
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" .el-row>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
